import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/USHA/Hero";
import IndustriesContent from "../components/USHA/IndustriesContent";
import PageTitle from "../components/USHA/PageTitle";

import '../assets/Webdevelopment.css';



const USHA = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  </div>
	)
}

export default USHA;
